module.exports = __webpack_public_path__ + "static/media/-_Sourcing & Recruitment.ac1d9cc1.png";